import { Button, Modal, Space, Typography } from 'antd';
import { memo, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

import { MIX_BUILDER_ROUTE } from '../../store/slices/yourLibrary';
import { uiActions } from '../../store/slices/ui';
import { useAppDispatch, useAppSelector } from '../../store/store';

export const ImportCompletionModal = memo(() => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const open = useAppSelector((state) => state.ui.importCompletionOpen);

  const handleClose = useCallback(() => {
    dispatch(uiActions.closeImportCompletion());
  }, [dispatch]);

  const handleGoToMixBuilder = useCallback(() => {
    dispatch(uiActions.closeImportCompletion());
    navigate(MIX_BUILDER_ROUTE, { state: { fromImportCompletion: true } });
  }, [dispatch, navigate]);

  if (!open) return null;

  return (
    <Modal
      width={560}
      style={{ maxWidth: 580, top: '30vh' }}
      open={open}
      footer={null}
      onCancel={handleClose}
      destroyOnClose
      maskClosable
      className='import-completion-modal'
      wrapClassName='overlay-modal'
    >
      <Space direction='vertical' size={20} style={{ display: 'flex' }}>
        <div className='import-completion-modal__text'>
          <Typography.Title
            level={4}
            style={{
              margin: 0,
              color: '#fff',
              fontSize: 24,
              fontWeight: 700,
              letterSpacing: -0.2,
              marginBottom: 12,
              textAlign: 'center',
            }}
          >
            Your library is ready!
          </Typography.Title>
          <Typography.Paragraph
            style={{
              marginTop: 0,
              marginBottom: 18,
              color: 'rgba(255, 255, 255, 0.82)',
              fontSize: 16,
              lineHeight: 1.45,
              textAlign: 'center',
            }}
          >
            We’ve finished importing your classical music.
          </Typography.Paragraph>
          <Typography.Paragraph
            style={{
              marginTop: 6,
              marginBottom: 18,
              color: 'rgba(255, 255, 255, 0.82)',
              fontSize: 16,
              lineHeight: 1.45,
              textAlign: 'center',
            }}
          >
            Let’s build your first mix.
          </Typography.Paragraph>
        </div>

        <div className='import-completion-modal__cta'>
          <Button
            type='primary'
            size='large'
            block
            onClick={handleGoToMixBuilder}
            style={{
              fontWeight: 700,
              height: 48,
              minWidth: 240,
              borderRadius: 8,
              fontSize: 16,
              background: '#3b82f6',
              borderColor: '#3b82f6',
            }}
          >
            Go to Mix Builder
          </Button>
        </div>
      </Space>
    </Modal>
  );
});

ImportCompletionModal.displayName = 'ImportCompletionModal';
